module.exports = __webpack_public_path__ + "static/media/agency_sidebar_bg2.f2ccdb86.jpg";